import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "create-card__title title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "field-icon" }
const _hoisted_6 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = ["onUpdate:modelValue", "disabled", "name"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-right material-icons input-icon" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_11 = { class: "field mt-6 mb-5" }
const _hoisted_12 = {
  key: 0,
  class: "control"
}
const _hoisted_13 = {
  key: 1,
  class: "control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-content input-card-data container create-update", { submitted: _ctx.submitted }])
    }, [
      _createVNode(_Transition, {
        mode: "out-in",
        name: "collapse"
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            autocomplete: "on",
            class: "create-card",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createVNode(_Transition, {
              mode: "out-in",
              name: "fade"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("header", {
                  class: "create-card__header mt-5",
                  key: _ctx.step
                }, [
                  _createElementVNode("h2", _hoisted_2, "Step " + _toDisplayString(_ctx.step) + "/2", 1),
                  _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.step === 1 ? 'Select' : 'Enter') + " fields", 1),
                  _hoisted_4
                ]))
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "field",
                key: field.key
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["field-top", _ctx.step === 2 && !field.show ? 'collapsed' : null])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_Transition, {
                      mode: "out-in",
                      name: "fade"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.step === 1)
                          ? (_openBlock(), _createBlock(_component_checkbox, {
                              key: 0,
                              checked: field.show,
                              "onUpdate:checked": ($event: any) => ((field.show) = $event),
                              id: field.name
                            }, null, 8, ["checked", "onUpdate:checked", "id"]))
                          : (_ctx.step === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(field.icon), 1))
                            : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("label", {
                    class: "label is-medium",
                    for: field.name
                  }, _toDisplayString(field.label), 9, _hoisted_7)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["control has-icons-left has-icons-right", _ctx.step === 2 && field.show ? 'open' : null])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    disabled: _ctx.step !== 2 || !field.show,
                    name: field.name
                  }, null, 8, _hoisted_8), [
                    [_vModelText, field.value]
                  ]),
                  _hoisted_9
                ], 2)
              ]))
            }), 128)),
            _hoisted_10,
            _createElementVNode("footer", _hoisted_11, [
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.getCardIsFilledState)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "button",
                          class: "button button__prev",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancelCardDataUpdate'))),
                          value: "Cancel"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("input", {
                      class: "button is-link button__next",
                      "data-test": "next-step",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {$event.preventDefault; _ctx.step = 2}),
                      value: "Next"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("input", {
                      type: "button",
                      class: "button button__prev",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 1)),
                      value: "Go back"
                    }),
                    _createElementVNode("button", {
                      "data-test": "submit-form",
                      type: "submit",
                      class: _normalizeClass(["button is-link button__next", { 'is-loading': _ctx.submitted }])
                    }, " Create QR ", 2)
                  ]))
            ])
          ], 32)
        ]),
        _: 1
      })
    ], 2)
  ]))
}